export default __webpack_public_path__ + "static/media/SOLUCIONESCARRITO.98094382.webp";